import React, { Component } from 'react';
import { Button, FormControl, OverlayTrigger, Popover } from 'react-bootstrap';
import "./VasYears.css"

interface VasYearsProps {
    appendParams: Function
    searchParams: Object
}

type VasYearsTypes = {
    StartYear: string
    EndYear: string
    eventType: string
    rangeError: boolean
    rangeErrorText: string
    rangeErrorType: string
}

class VasYears extends Component<VasYearsProps, VasYearsTypes> {

    state = {
        StartYear: "",
        EndYear: "",
        eventType: "",
        rangeError: false,
        rangeErrorText: "",
        rangeErrorType: ""
    }

    componentDidMount() {
        let param: any = this.props.searchParams
        this.setState({ StartYear: param.StartYear, EndYear: param.EndYear })
    }

    setEventType = (eventType: string) => {
        this.setState({ eventType: eventType })
    }

    initRangeError = (boundary: string, type: string) => {
        if (type === "min") {
            this.setState({ rangeError: true, rangeErrorType: "min", rangeErrorText: `The minimum Year range is ${boundary}. This field has been auto corrected to ${boundary}.` })
        }
        if (type === "max") {
            this.setState({ rangeError: true, rangeErrorType: "max", rangeErrorText: `The maximium Year range is ${boundary}. This field has been auto corrected to ${boundary}.` })
        }
        if (type === "min>max") {
            this.setState({ rangeError: true, rangeErrorType: "min", rangeErrorText: `You cannot have a Start Year value greater than an End Year value. This field has been auto corrected to ${boundary}.` })
        }
        if (type === "max<min") {
            this.setState({ rangeError: true, rangeErrorType: "max", rangeErrorText: `You cannot have an End Year value less than a Start Year value. This field has been auto corrected to ${boundary}.` })
        }
        const self = this
        setTimeout(function () {
            self.setState({ rangeError: false, rangeErrorType: "", rangeErrorText: "" })
        }, 7000)
    }

    handleChange = (event: { target: { value: any } }) => {
        let str = event.target.value.replace(/,/g, '')
        let max = new Date().getFullYear() + 1
        let min = 1969
        if (str.length < 5) {
            if (str.length === 4) {
                if (parseInt(str) < min && str.length === 4 && this.state.eventType === "StartYear") {
                    str = min + ""
                    this.initRangeError(min + "", "min")
                }
                if (parseInt(str) > max && str.length === 4 && this.state.eventType === "StartYear") {
                    str = max + ""
                    this.initRangeError(max + "", "min")
                }
                if (parseInt(str) > max && str.length === 4 && this.state.eventType === "EndYear") {
                    str = max + ""
                    this.initRangeError(max + "", "max")
                }
                if (parseInt(str) < min && str.length === 4 && this.state.eventType === "EndYear") {
                    str = min + ""
                    this.initRangeError(min + "", "max")
                }
                if (parseInt(str) > parseInt(this.state.EndYear) && str.length === 4 && this.state.eventType === "StartYear") {
                    str = (parseInt(this.state.EndYear) - 1) + ""
                    this.initRangeError(str, "min>max")
                }
                if (parseInt(str) < parseInt(this.state.StartYear) && str.length === 4 && this.state.eventType === "EndYear") {
                    if (parseInt(this.state.StartYear) < max - 1) {
                        str = (parseInt(this.state.StartYear) + 1) + ""
                        this.initRangeError(str, "max<min")
                    } else {
                        str = max + ""
                        this.initRangeError(str, "max<min")
                    }
                }
            }

            if (!isNaN(str)) {
                const eventTypes = Object.keys(this.state)
                for (let i = 0; i < eventTypes.length; i++) {
                    if (this.state.eventType === eventTypes[i]) {
                        const param: object = { [eventTypes[i]]: str }
                        this.setState(param)
                        this.props.appendParams([param])
                    }
                }
            }
        }
    }

    clearForm = (propertyName: any) => {
        this.setState({ [propertyName]: "" } as Pick<VasYearsTypes, keyof VasYearsTypes>)
        this.props.appendParams([{ [propertyName]: "" }])
    }

    render() {

        const rangeErrorPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h3">Value out of bounds.</Popover.Title>
                <Popover.Content>
                    {this.state.rangeErrorText}
                </Popover.Content>
            </Popover>
        )

        return (
            <div className="VAS-Years">
                <div className="VAS-Years-Input-Wrapper">
                    <div className="VAS-Years-Start-Wrapper" >
                        <div className="VAS-Years-Start-Input-Wrapper">
                            <FormControl
                                onFocus={() => this.setEventType("StartYear")}
                                placeholder={"Start Year"}
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.StartYear || ""}
                            />
                            {this.state.rangeError && (this.state.rangeErrorType === "min" || this.state.rangeErrorType === "min>max") && < OverlayTrigger show={true} placement="bottom" overlay={rangeErrorPopover}>
                                <div></div>
                            </OverlayTrigger>}
                            {this.state.StartYear.length > 0 && <Button id="vas-clear-param-btn-input" tabIndex={-1} onClick={() => this.clearForm("StartYear")}>
                                <span id="vas-clear-x-btn" className="material-icons">
                                    close
                                </span>
                            </Button>}
                        </div>
                    </div>
                    <div className="VAS-Years-End-Wrapper" >
                        <div className="VAS-Years-End-Input-Wrapper">
                            <FormControl
                                onFocus={() => this.setEventType("EndYear")}
                                placeholder={"End Year"}
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.EndYear || ""}
                            />
                            {this.state.rangeError && (this.state.rangeErrorType === "max" || this.state.rangeErrorType === "max<min") && < OverlayTrigger show={true} placement="bottom" overlay={rangeErrorPopover}>
                                <div></div>
                            </OverlayTrigger>}
                            {this.state.EndYear.length > 0 && <Button id="vas-clear-param-btn-input" tabIndex={-1} onClick={() => this.clearForm("EndYear")}>
                                <span id="vas-clear-x-btn" className="material-icons">
                                    close
                                </span>
                            </Button>}
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default VasYears